module.exports = __webpack_public_path__ + "static/img/btcnews.e32497c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/btcnews.png
// module id = 248t
// module chunks = 51